import * as React from "react";

// MARK: Mobx
import { observer, inject } from "mobx-react";

// MARK: Router
import { Route, Switch } from "react-router-dom";

// MARK: Stores
import AuthStore from "../../stores/AuthStore";

// MARK: Layout
import MainLayout from "../../layouts/MainLayout";

// MARK: Pages
import Surveys from "./Surveys";
import Bedrooms from "./Bedrooms";
import Banners from "./Banners";
import Offers from "./Offers";
import Rooms from "./Rooms";
import GastroPlaces from "./GastroPlaces";
import Home from "./Home";
import EditHotel from "./EditHotel";
import Gallery from "./Gallery";
import UIStore from "../../stores/_UIStore";
import { CircularProgress } from "@material-ui/core";

interface IProps {
	authStore: AuthStore;
	uiStore: UIStore;
}

@inject("authStore", "uiStore")
@observer
export default class Dashboard extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.authStore.authenticate();
	};

	public render() {
		return (
			<MainLayout>
				<Switch>
					<Route exact={true} path="/dashboard/" component={Home} />
					<Route path="/dashboard/surveys" component={Surveys} />
					<Route path="/dashboard/bedrooms" component={Bedrooms} />
					<Route path="/dashboard/banners" component={Banners} />
					<Route path="/dashboard/offers" component={Offers} />
					<Route path="/dashboard/rooms" component={Rooms} />
					<Route path="/dashboard/gastroplaces" component={GastroPlaces} />
					<Route path="/dashboard/answers" component={GastroPlaces} />
					<Route path="/dashboard/gallery" component={Gallery} />
					<Route path="/dashboard/edithotel" component={EditHotel} />
				</Switch>

				{this.props.uiStore.circularLoading && <CircularProgress />}
			</MainLayout>
		);
	}
}
